/**
 * Shared Recharts defaults.
 *
 * INITIAL_RC_DIM:
 *   Passed as `initialDimension` to every <ResponsiveContainer>.
 *   Recharts 3.x defaults to { width: -1, height: -1 } which triggers a
 *   "The width(-1) and height(-1) of chart should be greater than 0..."
 *   console warning on first render — *before* the ResizeObserver fires.
 *   Seeding both dimensions with a positive value silences the warning
 *   without affecting the rendered chart (the real dimensions take over
 *   the moment the container is measured).
 */
export const INITIAL_RC_DIM = { width: 100, height: 100 };
